import styled from 'styled-components';

export const Wrapper = styled.div`
  background: url('/404.png') center center;
  background-size: cover;
  background-color: #2253f5;
  min-height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  h1 {
    margin: 0;
    max-width: 800px;
    text-align: center;
    font-family: Montserrat;
    font-weight: bold;
    font-size: 24px;
    line-height: 140.62%;
    margin-bottom: 100px;
    color: #ffffff;
  }

  button {
    background: #fcff7c;
    color: #2253f5;
    width: 270px;
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 16px;
      line-height: 140.62%;
    }
  }
`;
